(() => {
  const thresholdSteps = 100;
  const threshold = Array(thresholdSteps).fill('').map((entry, index) => index / thresholdSteps);
  const elementsIntersectionRatiosMap = new Map();
  const elemCallbackTimers = window.WeakMap ? new WeakMap() : new Map();
  const elementsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const elem = entry.target;
      const { intersectionRatio } = entry;

      elementsIntersectionRatiosMap.set(elem, intersectionRatio);
    });
  }, {
    rootMargin: '-15% -25% -25% -25%',
    threshold,
  });
  const elemShowHideTimers = window.WeakMap ? new WeakMap() : new Map();
  const trackElement = (elem) => {
    elementsObserver.observe(elem);
  };
  const getActiveElement = (selector) => {
    let highestVisiblePixelCount = -1;
    let elem;

    elementsIntersectionRatiosMap.forEach((value, key) => {
      try {
        if (value === 0) {
          return;
        }
      } catch (e) {
        // noop
      }

      try {
        if (!key.isConnected) {
          return;
        }
      } catch (e) {
        // noop
      }

      try {
        if (value && key.matches(':focus-within')) {
          value *= 1.01;
        }
      } catch (e) {
        // noop
      }

      if (value && key.closest('dialog')) {
        value *= 1.02;
      }

      if (value && !key.closest('dialog') && document.documentElement.matches('.overlay-open')) {
        value /= 2;
      }

      try {
        const otherTrackedElems = [];
        elementsIntersectionRatiosMap.forEach((value, key) => {
          otherTrackedElems.push(key);
        });
        const isNestedInOtherTrackedElem = otherTrackedElems.find((elem) => {
          if (key === elem) {
            return false;
          }

          return elem.contains(key);
        });
        if (isNestedInOtherTrackedElem) {
          value *= 1.02;
        }
      } catch (e) {
        // noop
      }

      const elemGeometry = key.getBoundingClientRect();
      const totalPixelCount = elemGeometry.width * elemGeometry.height;
      const visiblePixelCount = value * totalPixelCount;

      if (visiblePixelCount > highestVisiblePixelCount) {
        highestVisiblePixelCount = visiblePixelCount;
        elem = key;
      }
    });

    if (typeof selector !== 'undefined' && typeof elem !== 'undefined' && elem.matches && !elem.matches(selector)) {
      return false;
    }

    return elem;
  };

  /* ------------- */

  const observedElements = new WeakMap();
  const callback = (entries) => {
    entries.forEach((entry) => {
      const elem = entry.target;
      const elemCallbacks = observedElements.get(elem);

      window.clearTimeout(elemCallbackTimers.get(elem));
      elemCallbackTimers.set(elem, window.setTimeout(() => {
        elemCallbacks.forEach((elemCallback) => elemCallback(entry.isIntersecting));
      }, 100));
    });
  };
  const intersectionObserver = window.IntersectionObserver ? new IntersectionObserver(callback, {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.001,
  }) : undefined;
  const observe = (elem, callback) => {
    const callbacks = observedElements.get(elem) || [];

    callbacks.push(callback);
    observedElements.set(elem, callbacks);
    intersectionObserver.observe(elem);
  };

  /* ------------- */
  let dataLayerPushed = false;

  document.addEventListener('focus', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem || (elem.matches && elem.matches('input, textarea, select, [contenteditable]'))) {
      return;
    }

    try {
      document.documentElement.classList[elem.matches(':focus-visible') ? 'add' : 'remove']('is-focus-visible');

      if (!dataLayerPushed && elem.matches(':focus-visible')) {
        dataLayerPushed = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'is-focus-visible' });
      }
    } catch (e) {
      // noop
    }
  }, true);

  window.swinger = window.swinger || {};
  window.swinger.visibility = {
    activeElement: {
      get: getActiveElement,
      track: trackElement,
    },
    observe,
    show: (elem) => {
      const id = elem.getAttribute('id');
      if (id) {
        document.querySelectorAll(`[aria-controls="${id}"]`).forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });
      }

      window.clearTimeout(elemShowHideTimers.get(elem));
      elem.removeAttribute('inert');
      elem.setAttribute('aria-hidden', 'false');

      if (elem.show) {
        try {
          elem.show();
        } catch (e) {
          // noop
        }
      }
    },
    hide: (elem, inertOnly = false) => {
      const focusedElement = document.activeElement;
      const id = elem.getAttribute('id');

      if (elem.contains(focusedElement)) {
        console.log('elem contains focus');

        const invoker = document.querySelector(`[aria-controls="${id}"][data-invoker]`);
        if (invoker) {
          invoker.focus();
        } else {
          const focusableElementsSelector = window.swinger.focusableElements.join(',');
          const focusableElements = window.swinger.$(focusableElementsSelector)
            .map((focusableElement) => !focusableElement.closest('[inert]'))
            .map((focusableElement) => focusedElement || !elem.contains(focusableElement));
          const focusedElementIndex = focusableElements.findIndex((focusableElement) => focusableElement === focusedElement);

          if (focusedElementIndex) {
            focusableElements[focusedElementIndex - 1].focus();
          } else {
            (document.querySelector('#header-home-link') || document.body).focus();
          }
        }
      }

      if (elem.close) {
        try {
          elem.close();
        } catch (e) {
          // noop
        }
      }

      try {
        elem.removeAttribute('open');
      } catch (e) {
        // noop
      }

      window.clearTimeout(elemShowHideTimers.get(elem));
      elemShowHideTimers.set(elem, window.setTimeout(() => {
        elem.setAttribute('aria-hidden', inertOnly ? 'false' : 'true');
        elem.setAttribute('inert', '');

        document.querySelectorAll(`[aria-controls="${id}"]`).forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
      }));
    },
  };
})();
